import templateUrl from './user-edit-form.html';

export default {
  templateUrl,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    accessLevels: '<',
    user: '<',
    showAccessLevel: '<',
    onUserChanged: '&'
  },
  controller: class UserEditFormComponent {
    constructor(EventEmitter) {
      'ngInject';

      Object.assign(this, { EventEmitter });
    }

    $onInit() {
      this.user = this.user || {};
    }

    onSubmit() {
      this.onUserChanged(
        this.EventEmitter({
          user: this.user
        })
      );
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/common/user-edit-form/user-edit-form.component.js